<template>
    <Sider
        :collapsed-width="78"
        :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}"
    >
        <!-- <Menu>首页</Menu> -->
        <div class="homeTip" @click="gohome" :style="{'background':colorHome}" v-if="offhome">
            <img src="../../assets/home.png" alt="">
            <span>首页</span>
        </div>
        <Menu
            v-if="sideList && sideList.length"
            theme="dark"
            width="auto"
            :active-name="activeName"
            :open-names="[openName]"
            @on-select="onMenuSelect"
            class="menus"
        >
            <Submenu
                :name="(indexone+1).toString()"
                v-for="(itemone, indexone) in sideList"
                :key="indexone"
                :id="indexone"
                @click="oneTab(itemone)"
            >
                <template slot="title">
                    <Icon :type="itemone.icon"></Icon>
                    {{itemone.name}}
                </template>
                <MenuItem
                    :name="(indexone+1)+'-'+(indexesc+1)"
                    v-for="(itemsec, indexesc) in itemone.children"
                    :key="indexesc"
                >{{itemsec.name}}</MenuItem>
            </Submenu>
        </Menu>
    </Sider>
</template>
<script>
import common from "../../common/common.js";
export default {
  name: "Side",
  data() {
    return {
      offhome: true,
      sideList:[],
      sideList1: [
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "补贴配置管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: "22",
              name: "补贴管理",
              router_name: "subsidiesManage"
            }
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "系统管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
              {
              id: 89,
              name: "部门管理",
              router_name: "systemSections"
            },
            {
              id: 89,
              name: "配置管理",
              router_name: "configManage"
            },
            {
              id: 89,
              name: "角色管理",
              router_name: "rolesManage"
            },
            {
              id: 90,
              name: "权限管理",
              router_name: "permissionsManage"
            },
            {
              id: 90,
              name: "用户管理",
              router_name: "usersManage"
            }
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "合同管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: "22",
              name: "报价管理",
              router_name: "contractManage"
            }
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "工具管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 90,
              name: "领取管理",
              router_name: "toolReceives"
            },
            {
              id: 90,
              name: "工具管理",
              router_name: "toolsManage"
            },
            {
              id: 90,
              name: "借用管理",
              router_name: "toolBorrows"
            },
          ]
        },
        // lll
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "任务管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 55,
              name: "任务用户管理",
              router_name: "taskUserManage"
            },
            {
              id: 90,
              name: "任务列表",
              router_name: "taskManage"
            },
            {
              id: 55,
              name: "任务进度管理",
              router_name: "taskProgressManage"
            },
            {
              id: 55,
              name: "任务常见失败原因",
              router_name: "taskDidManage"
            },
            {
              id: 55,
              name: "任务评价管理",
              router_name: "taskServicesManage"
            },
            {
              id: 55,
              name: "任务级别管理",
              router_name: "taskLevelsManage"
            },
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "供应商管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 90,
              name: "供应商登记",
              router_name: "supplierManage"
            },
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "客户管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 90,
              name: "客户统计",
              router_name: "customerCensusManage"
            },
          ]
        },
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "行程登记管理",
          router_name: "contractModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 90,
              name: "行程登记",
              router_name: "itineraryRegistration"
            },
          ]
        },
        // df
        {
          created_at: "2018-09-12 11:11:30",
          icon: "icon-caidan",
          id: 82,
          level_id: 1,
          name: "费用申请管理",
          router_name: "feeApplyModel",
          showif: 1,
          sort_num: 1,
          top_id: 0,
          top_router: "",
          updated_at: "2018-09-12 11:11:30",
          children: [
            {
              id: 89,
              name: "工作单",
              router_name: "jobManage"
            },
            {
              id: 89,
              name: "费用申请单",
              router_name: "feeApplyManage"
            },
            
            {
              id: 90,
              name: "付款统计",
              router_name: "paymentManage"
            },
            {
              id: 90,
              name: "入库统计",
              router_name: "putStorageManage"
            },
            {
              id: 90,
              name: "出库统计",
              router_name: "outStorageManage"
            },
            {
              id: 90,
              name: "配件库存统计",
              router_name: "partsStockManage"
            },
            {
              id: 90,
              name: "发票开具",
              router_name: "invoiceIssue"
            },
            {
              id: 90,
              name: "报表",
              router_name: "reportForm"
            },
            
            {
              cid: 90,
              name: "个人工具领取登记",
              router_name: "personalReceiveRecord"
            },
            {
              id: 90,
              name: "工具领取表",
              router_name: "toolReceiveRecord"
            },
            {
              id: 90,
              name: "工具库存",
              router_name: "toolStock"
            },
            {
              id: 90,
              name: "个人报销",
              router_name: "personalReimbursement"
            },
            {
              id: 90,
              name: "个人购买配件",
              router_name: "personalbuyParts"
            }
          ]
        }
      ],
      tabData: [],
      colorHome: "#2d8cf0", //设置首页菜单的背景色  高亮
      activeName: "", //父级子菜单高亮
      openName: "" // 父级展开菜单
    };
  },
  methods: {
    getSide() {
      this.axios
        .get(this.config.urlArray.getSide, {})
        .then(result => {
          common.ajaxMsg(result.data);
          this.$nextTick(() => {
            let sideList = result.data.data;
            sideList.map((item,index)=>{
                item.router_name = item.route
                if(item.children){
                    item.children.map((item1,index1)=>{
                        item1.router_name = item1.route
                        return item1
                    })
                }
                return item
            })
            this.sideList = sideList;
          });
        })
        .catch(err => {
          common.msg("error", "侧栏获取失败", () => {});
        });
    },
    onMenuSelect(name) {
      // 设置动态导航  改变全局变量  循环导航
      this.tabData = [];
      let numA = name.split("-");
      let one = numA[0];
      let sec = numA[1];
      this.tabData.push(
        this.sideList[one - 1].name,
        this.sideList[one - 1].children[sec - 1].name
      );
      this.$store.commit("setCrumbs", { crumbs: this.tabData });
      sessionStorage.setItem("menu", this.tabData);
      // 进行动态路由的跳转
      let router_name = this.sideList[one - 1].children[sec - 1].router_name;
      this.colorHome = "";
      this.activeName = `${one}-${sec}`;
      this.openName = `${one}`;
      sessionStorage.setItem(
        "slieLight",
        JSON.stringify({
          activeName: `${one}-${sec}`,
          openName: `${one}`
        })
      );
      this.$router.push({ name: router_name, params: {} });
    },
    gohome() {
      if (!this.offhome) {
        return;
      }
      console.log(111);
      this.$store.commit("setCrumbs", { crumbs: "" });
      this.colorHome = "#2d8cf0";
      this.activeName = "";
      this.$store.commit("setCrumbs", { crumbs: ["首页"] });
      window.sessionStorage.setItem("slieLight", "");
      this.$router.push({ name: "home", params: {} });
    }
  },
  created() {
    this.$nextTick(() => {
      // let uInfos = window.sessionStorage.getItem('uInfo')
      // uInfos = JSON.parse(uInfos)
      // if(uInfos.isSales){
      //     this.offhome = !uInfos.isSales
      // }
      if (window.sessionStorage.getItem("slieLight")) {
        if (JSON.parse(window.sessionStorage.getItem("slieLight"))) {
          let side = JSON.parse(window.sessionStorage.getItem("slieLight")); // 获取高亮的导航栏
          this.activeName = side.activeName;
          this.openName = side.openName;
          this.colorHome = "";
        }
      }
    });
  },
  mounted: function() {
    this.getSide();
    let datas = window.sessionStorage.getItem("menu");
    if (window.sessionStorage.getItem("menu")) {
      let data = datas.split(",");
      this.$store.commit("setCrumbs", { crumbs: data });
    } else {
      this.$store.commit("setCrumbs", { crumbs: ["首页"] });
    }
  }
};
</script>
<style scoped>
.ivu-layout-sider {
  z-index: 3;
}
a {
  color: rgba(255, 255, 255, 0.7) !important;
}
.homeTip {
  cursor: pointer;
}
.homeTip img {
  width: 30px;
  height: 30px;
}
.homeTip span {
  color: #fff;
  margin: 0px 10px;
}
.homeTip {
  padding: 10px 15px;
  box-sizing: border-box;
  text-align: left;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.homeTip:hover {
  background: #2d8cf0 !important;
}
/* 菜单悬浮高亮 */
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover {
  background: #2d8cf0 !important;
}

.layout-con {
  height: 100%;
  width: 100%;
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
/* @media only screen and (min-width: 120px) {
        .ivu-menu {
           display: none !important;
        }
    } */
.ivu-form .ivu-form-item-label {
  max-width: 120px !important;
  text-align: center !important;
  text-indent: 1px;
}
.ivu-form-item-content {
  margin-left: 120px !important;
}

::-webkit-scrollbar {
  width: 0px;
  height: 4px;
}
/*滑动轨道*/
::-webkit-scrollbar-track {
  border-radius: 0px;
  background: none;
}
/*滑块*/
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.75);
}
/*滑块效果*/
::-webkit-scrollbar-thumb:hover {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: rgba(85, 85, 85, 0.4);
}
</style>

